import { render, staticRenderFns } from "./kafpos-form-loading.vue?vue&type=template&id=5e9759c5&scoped=true&lang=pug"
import script from "./kafpos-form-loading.vue?vue&type=script&setup=true&lang=js"
export * from "./kafpos-form-loading.vue?vue&type=script&setup=true&lang=js"
import style0 from "./kafpos-form-loading.vue?vue&type=style&index=0&id=5e9759c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e9759c5",
  null
  
)

export default component.exports